import { useCallback, useEffect, useState } from "react";
import {
  createVehicleRequest,
  deleteVehicleRequest,
  getVehiclesListRequest,
} from "../network";

export const useVehicleList = () => {
  const [vehiclesList, setVehiclesList] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState<boolean>(false);

  const getVehiclesList = useCallback(async () => {
    setVehicleLoading(true);
    const res = await getVehiclesListRequest();
    setVehiclesList(res.data);
    setVehicleLoading(false);

    return res;
  }, []);

  const setVehicle = useCallback(async (values) => {
    const fd = new FormData();
    for (let value in values) {
      if (values[value] && ["main_image"].includes(value)) {
        fd.append(value, values[value][0]);
      } else {
        fd.append(value, values[value]);
      }
    }
    const res = await createVehicleRequest(fd);
    return res;
  }, []);

  const deleteVehicle = useCallback(async (id) => {
    const res = await deleteVehicleRequest(id);
    await getVehiclesList();
    return res;
  }, []);

  useEffect(() => {
    getVehiclesList();
  }, []);

  return { vehiclesList, setVehicle, deleteVehicle, vehicleLoading };
};
